/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_Refused_OwnInputs */

const en_vendor_return_status_refused_own = /** @type {(inputs: Vendor_Return_Status_Refused_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refused: Tomorrow decides`)
};

/**
* | output |
* | --- |
* | "Refused: Tomorrow decides" |
*
* @param {Vendor_Return_Status_Refused_OwnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_refused_own = /** @type {((inputs?: Vendor_Return_Status_Refused_OwnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_Refused_OwnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_refused_own(inputs)
});